import { ReviewReason } from "src/store/api/generatedApi";
import {
  FLAGGED_REVIEW_REASON,
  ReviewReasonFilter,
  ReviewReasonFilterValue,
  UNFLAGGED_REVIEW_REASON,
} from "components/manualReview/filters/eventFilters";
import { REVIEW_REASON_PRIORITY_VALUES } from "components/manualReview/utils/reviewReasons";
import { Serialiser } from "./types";

const ANY_REASON_TOKEN = "any";

const parseReason = (value: string): ReviewReasonFilterValue | null =>
  value === FLAGGED_REVIEW_REASON || value === UNFLAGGED_REVIEW_REASON
    ? value
    : (REVIEW_REASON_PRIORITY_VALUES as readonly string[]).includes(value)
      ? (value as ReviewReason)
      : null;

export const reviewReasonListSerialiser: Serialiser<
  ReviewReasonFilter[],
  never
> = {
  format: (value) =>
    value.map((filter) => filter.reason ?? ANY_REASON_TOKEN).join(","),
  parse: (text) => {
    if (text.length === 0) return { valid: true, value: [] };
    const value = text
      .split(",")
      .map((token) => ({ reason: parseReason(token) }));
    return { valid: true, value };
  },
};
